import { translateFn } from '../../../../../../../../../../utils/translator.helper';
import { RequiredValidator } from '../../../../../../../../../../ui/gzForm/validators/required.validator';

// validators for the scope group
export const ruleScopeSpecificValidators = () => [
  RequiredValidator(translateFn('Select at least one group when defining the rule for specific targets.')),
];
